module.exports = __webpack_public_path__ + "static/img/debtor_icon.5810c793.svg";